/**
 * Métodos de pago especiales que requieren lógica diferente
 */
export const SPECIAL_PAYMENT_METHODS = ['BA2014', 'BD2001'];

/**
 * Tasa de interés por defecto (9% anual)
 */
export const DEFAULT_INTEREST_RATE = 0.09;

/**
 * Fechas y montos iniciales para el formulario
 */
export const INITIAL_DUE_DATES = {
  amounts: {
    due1: 0,
    due2: 0,
    due3: 0,
  },
  dates: {
    due1: new Date(),
    due2: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // +7 días
    due3: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000), // +14 días
  },
  differences: {
    diff1: '0.00',
    diff2: '0.00',
    diff3: '0.00',
  }
};

/**
 * Validaciones del formulario
 */
export const FORM_VALIDATION = {
  CONTRACT_MIN: 1,
  COEFFICIENT_MIN: 0,
  DEFERMENT_MIN: 0,
  DEFERMENT_MAX: 100,
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: '¡Cupón generado con éxito! Ya puede descargar el cupón.',
  CANCELLED: 'Generación de cupón cancelada con éxito',
  ERROR_DEFAULT: 'Ocurrió un error inesperado. Por favor intente nuevamente.',
  ERROR_QUOTA: 'Error al verificar cuota. Intente nuevamente.',
  CONTRACT_VALIDATION: 'Debe introducir un número de contrato válido',
  CONFIRM_GENERATION: 'Toque confirmar para generar los cupones.',
  EXCLUDE_CONTRACTS: 'Tildar el contrato para no generar cupón:',
  NAVIGATE_PROMPT: 'Para ver todos los cupones toque el botón',
  ADECUACION_TITLE: 'ADECUACIÓN',
  NO_CALCULATE_INTEREST: 'No calcular Interés',
  GENERATION_TITLE: 'Habitat 99 | Cupones | Generar cupones',
  GENERATE_BUTTON: 'Generar',
  CLOSE_BUTTON: 'Cerrar',
  CONFIRM_BUTTON: 'Confirmar',
  VIEW_COUPONS_BUTTON: 'Ver Cupones',
};

/**
 * Configuración responsive
 */
export const RESPONSIVE_CONFIG = {
  DIALOG: {
    maxWidth: { xs: '95%', sm: '90%', md: '80%' },
    margin: { xs: '8px', sm: '16px', md: '32px' },
  },
  FORM: {
    padding: { xs: '15px', sm: '25px', md: '35px' },
    spacing: { xs: 1, sm: 2, md: 3 },
  },
  FIELDS: {
    marginTop: { xs: '8px', sm: '12px' },
    fontSize: { xs: '14px', sm: '16px' },
    width: { xs: '100%', sm: '48%', md: '30%' },
    marginBottom: { xs: 2, md: 0 },
  },
  HEADER: {
    padding: { xs: '8px', sm: '16px' },
    titleFontSize: { xs: '20px', sm: '24px', md: '32px' },
    buttonFontSize: { xs: '14px', sm: '16px' },
    buttonPadding: { xs: '6px 16px', sm: '6px 24px' },
  },
  DUE_DATES: {
    containerDirection: { xs: 'column', sm: 'row' },
    fieldGap: { xs: 1, sm: 0 },
    titleFontSize: { xs: '18px', md: '24px' },
    inputFontSize: { xs: '14px', md: '16px' },
  },
};

/**
 * Configuración de animaciones
 */
export const ANIMATIONS = {
  FADE_IN: {
    animation: 'fadeIn 0.5s ease-in-out',
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateX(20px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)'
      }
    }
  },
  FADE_IN_DELAYED: (delay = '0.1s') => ({
    animation: 'fadeIn 0.5s ease-in-out',
    animationDelay: delay,
    animationFillMode: 'both',
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateX(20px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)'
      }
    }
  }),
};

/**
 * Estilos de campos comunes
 */
export const FIELD_STYLES = {
  BASE: {
    mr: 0.5,
    ml: 0.5,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  },
  FLEX_NORMAL: (showDifferenceColumn) => ({
    mr: 0.5,
    ml: 0.5,
    flex: showDifferenceColumn ? 1 : 1.5,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  }),
  FLEX_FULL: {
    mr: 0.5,
    ml: 0.5,
    flex: 1,
    '& .MuiInputBase-input': {
      fontSize: { xs: '14px', md: '16px' },
    },
  },
};

/**
 * Labels de formulario
 */
export const FORM_LABELS = {
  BRANCH: 'Sucursal',
  PLAN: 'Plan',
  GROUP: 'Grupo',
  PAYMENT_METHOD: 'Forma de Pago',
  CONTRACT: 'Solo un contrato',
  DEFERMENT_PERCENTAGE: '% de Diferimiento',
  COEFFICIENT: 'Coeficiente de puntaje',
  FIRST_DUE: '1er vto',
  SECOND_DUE: '2do vto',
  THIRD_DUE: '3er vto',
  DATE: 'Fecha',
  DIFFERENCE_VALUE: 'Valor Difer.',
  ALL: 'Todos',
};

/**
 * Configuración de íconos
 */
export const ICONS_CONFIG = {
  PUBLISH: {
    color: 'whitesmoke',
    fontSize: { xs: '20px', sm: '24px' }
  },
  CHECKBOX: {
    fontSize: { xs: '20px', md: '24px' }
  },
};